import axios from "axios";
import { del, get, post, put } from "../../services/ApiRouting";

// Function to fetch all members
export async function getAllMembres(page = 1) {
  try {
    const response = await get(`${API_URL}/crud/members?page=${page}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching services:", error);
    throw error.response ? error.response.data : new Error("Network Error");
  }
}
export async function getTeam() {
  try {
    const response = await get(`${API_URL}/crud/members?filter=all`);
    return response;
  } catch (error) {
    console.error("Error fetching services:", error);
    throw error.response ? error.response.data : new Error("Network Error");
  }
}

// Function to create a new membre
export async function createMembre(membreData) {
  try {
    const response = await post(`${API_URL}/crud/members`, membreData);
    return response;
  } catch (error) {
    console.error("Error creating membre:", error);
    throw error.response ? error.response.data : new Error("Network Error");
  }
}

// Function to fetch a single membre by ID
export async function getMembreById(token, membreId) {
  const response = await axios.get(`${API_URL}/crud/members/${membreId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  });
  return response.data;
}

// Function to update an existing membre
export async function updateMembre(membreId, membreData) {
  const response = await put(`${API_URL}/crud/members/${membreId}`, membreData);
  return response;
}

// Function to delete a membre
export async function deleteMembre(membreId) {
  const response = await del(`${API_URL}/crud/members/${membreId}`);
  return response;
}
